import type { ReactNode } from 'react';

import microsoftIcon from '../../../assets/icons/microsoft_icon.svg';

interface MicrosoftLogoProps {
  className?: string;
}

export function MicrosoftLogo({
  className,
}: Readonly<MicrosoftLogoProps>): ReactNode {
  return (
    <img
      data-icon
      src={microsoftIcon}
      className={className}
      alt=""
      aria-hidden="true"
    />
  );
}
